// Arbitrary distance that looks nice
export const INITIAL_REGION_DELTA = 0.005;

/**
 * margins for the 'safe zone' where a user can safely click on a
 * marker without auto centering around the location
 */
export const MAP_SAFE_ZONE_TOP_MARGIN = 64;
export const MAP_SAFE_ZONE_BOTTOM_MARGIN = 500;
export const MAP_SAFE_ZONE_SIDE_MARGIN = 24;

export const DEBUG_SAFE_ZONE = false;

// Shared z-index stack for map overlays
export const MAP_Z_INDEX = {
  pin: 0,
  pinCard: 2,
  selectedPin: 1,
};
